module.exports = __webpack_public_path__ + "img/revenue-streams.f4d359f2.png";